import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";

export const ProductionAndSalesWithPaymentsDetailCosts = () => {
    const tableName = "products";
    const { t } = useTranslation();

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"costs"}>
                <NFLookupUnit title={t("unitId")} fieldName="Unit" />
                <NFIntInput title={t("quantity")} fieldName="quantity" />
                <NFIntInput title={t("price")} fieldName="price" />
                <NFIntInput title={t("amount")} fieldName="amount" />
                <NFLookupAccount
                    title={t("Cost Account")}
                    fieldName="costAccountId"
                />
                <NFLookupProduct title={t("Product")} fieldName="productId" />
            </NFormTable>
        </>
    );
};
